import { createSelector } from 'reselect'
import getMessageBannerSelector from 'modules/banner/selectors/get-message'

const hasBannerSelect = createSelector(
  getMessageBannerSelector(),
  bannerMessage => !!bannerMessage
)

export default hasBannerSelect
